export default __webpack_public_path__ + "static/featured_properties1-feef98f04522b723a76d12f6506fe76e.png";